import { render, staticRenderFns } from "./SingpassLogin.vue?vue&type=template&id=eb2b98f8&"
import script from "./SingpassLogin.vue?vue&type=script&lang=js&"
export * from "./SingpassLogin.vue?vue&type=script&lang=js&"
import style0 from "./SingpassLogin.vue?vue&type=style&index=0&id=eb2b98f8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports